import { apiService } from './apiService'
import { inviteEndpoints } from '../api/apiEndpoint'
import { DefaultResponse } from '@/common/types/common'
import {
  CompanyUserInvite,
  PitchReviewerInvite,
  InvestReviewerInvite
} from '@/common/types/invitation'
import { RegisterUserRequest } from './authService'
export const inviteService = {
  async getInviteInfoForCompanyUser(
    notificationId: string
  ): Promise<CompanyUserInvite | null> {
    try {
      const response = await apiService.get<CompanyUserInvite>(
        inviteEndpoints.getInviteInfoForCompanyUser(notificationId)
      )
      return response as CompanyUserInvite
    } catch (err: any) {
      console.error(err)
      return null
    }
  },

  async getInviteInfoForPitchReviewer(
    notificationId: string
  ): Promise<PitchReviewerInvite | null> {
    try {
      const response = await apiService.get<PitchReviewerInvite>(
        inviteEndpoints.getInviteInfoForPitchReviewer(notificationId)
      )
      return response as PitchReviewerInvite
    } catch (err: any) {
      console.error(err)
      return null
    }
  },

  async getInviteInfoForInvestReviewer(
    notificationId: string
  ): Promise<InvestReviewerInvite | null> {
    try {
      const response = await apiService.get<InvestReviewerInvite>(
        inviteEndpoints.getInviteInfoForInvestReviewer(notificationId)
      )
      return response as InvestReviewerInvite
    } catch (err: any) {
      console.error(err)
      return null
    }
  },

  async acceptInviteForRegister(
    data: RegisterUserRequest
  ): Promise<DefaultResponse | null> {
    try {
      const response = await apiService.patch<DefaultResponse>(
        inviteEndpoints.acceptInveteForRegister(),
        data
      )
      return response
    } catch (err: any) {
      console.error(err)
      return null
    }
  },

  async acceptInviteForLogin(
    notificationId: string
  ): Promise<DefaultResponse | null> {
    try {
      const response = await apiService.patch<DefaultResponse>(
        inviteEndpoints.acceptInviteForLogin(notificationId)
      )
      return response
    } catch (err: any) {
      console.error(err)
      return null
    }
  },

  async rejectInvite(data: {
    notificationId: string
    reason: string
  }): Promise<DefaultResponse | null> {
    try {
      const response = await apiService.patch<DefaultResponse>(
        inviteEndpoints.rejectInvite(data.notificationId)
      )
      return response
    } catch (err: any) {
      console.error(err)
      return null
    }
  }
}
